const NoteReviewIcon = () => {
  return (
    <svg data-testid="qaNotReviewIcon" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_3806_54864)">
        <path
          d="M4 20C4 8.95431 12.9543 0 24 0C35.0457 0 44 8.95431 44 20C44 31.0457 35.0457 40 24 40H4V20Z"
          fill="#FCFCFC"
        />
      </g>
      <circle cx="24" cy="20" r="16" fill="#7EC665" />
      <path
        d="M7.00907 38.1668C6.78822 38.1668 6.5995 38.0882 6.4429 37.9309C6.28631 37.7736 6.20801 37.5846 6.20801 37.3637C6.20801 37.1429 6.28665 36.9542 6.44392 36.7976C6.60119 36.641 6.79026 36.5627 7.01111 36.5627C7.23196 36.5627 7.42068 36.6413 7.57728 36.7986C7.73388 36.9558 7.81217 37.1449 7.81217 37.3658C7.81217 37.5866 7.73354 37.7753 7.57626 37.9319C7.41899 38.0885 7.22993 38.1668 7.00907 38.1668ZM9.98824 38.1668C9.76739 38.1668 9.57867 38.0882 9.42207 37.9309C9.26547 37.7736 9.18717 37.5846 9.18717 37.3637C9.18717 37.1429 9.26581 36.9542 9.42309 36.7976C9.58036 36.641 9.76942 36.5627 9.99028 36.5627C10.2111 36.5627 10.3998 36.6413 10.5564 36.7986C10.713 36.9558 10.7913 37.1449 10.7913 37.3658C10.7913 37.5866 10.7127 37.7753 10.5554 37.9319C10.3982 38.0885 10.2091 38.1668 9.98824 38.1668ZM7.00907 35.3022C6.78822 35.3022 6.5995 35.2236 6.4429 35.0663C6.28631 34.9091 6.20801 34.72 6.20801 34.4991C6.20801 34.2783 6.28665 34.0896 6.44392 33.933C6.60119 33.7764 6.79026 33.6981 7.01111 33.6981C7.23196 33.6981 7.42068 33.7767 7.57728 33.934C7.73388 34.0913 7.81217 34.2803 7.81217 34.5012C7.81217 34.722 7.73354 34.9108 7.57626 35.0674C7.41899 35.2239 7.22993 35.3022 7.00907 35.3022ZM9.98824 35.3022C9.76739 35.3022 9.57867 35.2236 9.42207 35.0663C9.26547 34.9091 9.18717 34.72 9.18717 34.4991C9.18717 34.2783 9.26581 34.0896 9.42309 33.933C9.58036 33.7764 9.76942 33.6981 9.99028 33.6981C10.2111 33.6981 10.3998 33.7767 10.5564 33.934C10.713 34.0913 10.7913 34.2803 10.7913 34.5012C10.7913 34.722 10.7127 34.9108 10.5554 35.0674C10.3982 35.2239 10.2091 35.3022 9.98824 35.3022ZM7.00907 32.4377C6.78822 32.4377 6.5995 32.359 6.4429 32.2017C6.28631 32.0445 6.20801 31.8554 6.20801 31.6346C6.20801 31.4137 6.28665 31.225 6.44392 31.0684C6.60119 30.9118 6.79026 30.8335 7.01111 30.8335C7.23196 30.8335 7.42068 30.9121 7.57728 31.0694C7.73388 31.2267 7.81217 31.4157 7.81217 31.6366C7.81217 31.8574 7.73354 32.0462 7.57626 32.2028C7.41899 32.3594 7.22993 32.4377 7.00907 32.4377ZM9.98824 32.4377C9.76739 32.4377 9.57867 32.359 9.42207 32.2017C9.26547 32.0445 9.18717 31.8554 9.18717 31.6346C9.18717 31.4137 9.26581 31.225 9.42309 31.0684C9.58036 30.9118 9.76942 30.8335 9.99028 30.8335C10.2111 30.8335 10.3998 30.9121 10.5564 31.0694C10.713 31.2267 10.7913 31.4157 10.7913 31.6366C10.7913 31.8574 10.7127 32.0462 10.5554 32.2028C10.3982 32.3594 10.2091 32.4377 9.98824 32.4377Z"
        fill="#A9A9A9"
      />
      <path
        d="M21.75 19.25L24 21.5L31.5 14"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.75 20V25.25C30.75 25.6478 30.592 26.0294 30.3107 26.3107C30.0294 26.592 29.6478 26.75 29.25 26.75H18.75C18.3522 26.75 17.9706 26.592 17.6893 26.3107C17.408 26.0294 17.25 25.6478 17.25 25.25V14.75C17.25 14.3522 17.408 13.9706 17.6893 13.6893C17.9706 13.408 18.3522 13.25 18.75 13.25H27"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id="filter0_d_3806_54864"
          x="0"
          y="0"
          width="48"
          height="48"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3806_54864" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3806_54864"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default NoteReviewIcon;
